"use strict";
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAddressString = exports.checkAddressCheckSum = void 0;
const keccak_js_1 = require("@theqrl/qrl-cryptography/keccak.js");
const utils_js_1 = require("@theqrl/qrl-cryptography/utils.js");
// eslint-disable-next-line import/no-cycle
const utils_js_2 = require("../utils.js");
/**
 * Checks the checksum of a given address. Will also return false on non-checksum addresses.
 */
const checkAddressCheckSum = (data) => {
    if (!/^Q[0-9a-f]{40}$/i.test(data))
        return false;
    const address = data.slice(1);
    const updatedData = (0, utils_js_1.utf8ToBytes)(address.toLowerCase());
    const addressHash = (0, utils_js_2.uint8ArrayToHexString)((0, keccak_js_1.keccak256)(updatedData)).slice(2);
    for (let i = 0; i < 40; i += 1) {
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) ||
            (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
            return false;
        }
    }
    return true;
};
exports.checkAddressCheckSum = checkAddressCheckSum;
/**
 * Checks if a given string is a valid QRL address. It will also check the checksum, if the address has upper and lowercase letters.
 */
const isAddressString = (value, checkChecksum = true) => {
    if (typeof value !== 'string') {
        return false;
    }
    // check if it has the basic requirements of an address
    if (!/^Q[0-9a-f]{40}$/i.test(value)) {
        return false;
    }
    // If it's ALL lowercase or ALL upppercase
    if (/^Q[0-9a-f]{40}$/.test(value) || /^Q[0-9A-F]{40}$/.test(value)) {
        return true;
        // Otherwise check each case
    }
    return checkChecksum ? (0, exports.checkAddressCheckSum)(value) : true;
};
exports.isAddressString = isAddressString;
//# sourceMappingURL=address.js.map